<section class="main-content">
    <div class="content-confirmacion-asegurado">
        <div class="titulo-contenido-principal">
            <h1 class="titulo-principal text-center text-color-primary"
                [innerHTML]="'solicitud-curso.titulo' | translate"></h1>
            <p class="detalle-titulo text-center" [innerHTML]="'solicitud-curso.titulo.detalle' | translate"></p>
        </div>
        <div class="form-group" id="resumen-contratacion">
            <h2 class="text-color-primary text-mediano">{{'solicitud-curso.cobertura.resumen' | translate}}</h2>
            <div class="content-resument-item">
                <label class="campo-resument-item">{{'solicitud-curso.cobertura.seguro' | translate}}</label>
                <span class="result-resumen-item">{{ poliza.tipoPoliza.nombre }}</span>
            </div>
            <div class="content-resument-item formateoDerecha">
                <label class="campo-resument-item">{{'solicitud-curso.cobertura.fallecimiento-causa' |
                    translate}}</label>
                <span class="result-resumen-item">
                    {{ poliza.capitalCobertura | currencyEuroSinDecimales }}
                </span>
            </div>
            <div class="content-resument-item formateoDerecha">
                <label class="campo-resument-item">{{'solicitud-curso.cobertura.fallecimiento-accidente' |
                    translate}}</label>
                <span class="result-resumen-item">
                    {{ poliza.capitalAccidenteFallecimiento | currencyEuroSinDecimales }}
                </span>
            </div>
            <div class="content-resument-item formateoDerecha">
                <label class="campo-resument-item">{{'solicitud-curso.cobertura.incapacidad-accidente' |
                    translate}}</label>
                <span class="result-resumen-item">
                    {{ poliza.capitalAccidenteInvalidez | currencyEuroSinDecimales }}
                </span>
            </div>
            <div class="content-resument-item">
                <label class="campo-resument-item">{{'solicitud-curso.cobertura.precio-mensual' | translate}}</label>
                <span class="result-resumen-item">{{poliza.precioMensual | currencyEuroSinDecimales }}</span>
            </div>

            <ng-container *ngIf="(poliza.tipoPoliza.id === 2)">
                <div class="content-resument-item">
                    <label class="campo-resument-item">{{'solicitud-curso.cobertura.nombreBanco' | translate}}:</label>
                    <span class="result-resumen-item">{{ poliza.beneficiarioList[0].nombreBanco }}</span>
                </div>
                <div class="content-resument-item">
                    <label class="campo-resument-item">{{'solicitud-curso.cobertura.numeroPrestamo' |
                        translate}}:</label>
                    <span class="result-resumen-item">{{ poliza.beneficiarioList[0].numeroPrestamo }}</span>
                </div>
            </ng-container>


            <ng-container *ngIf="poliza.beneficiarioList && poliza.beneficiarioList.length > 0">
                <div class="content-resument-item" *ngFor="let beneficiario of poliza.beneficiarioList; let i = index">
                    <ng-container *ngIf="!(poliza.tipoPoliza.id === 2) || ((poliza.tipoPoliza.id === 2) && i !== 0)">
                        <label class="campo-resument-item">{{'solicitud-curso.cobertura.beneficiario' | translate}} {{
                            (poliza.tipoPoliza.id === 2) ? i : i + 1 }}:</label>
                        <span class="result-resumen-item">{{ (poliza.tipoPoliza.id === 2) ? beneficiario.nombreCompleto : 
                            beneficiario.nombreCompleto + ' ' + beneficiario.porcentaje + '%'}}</span>
                        <br>
                        <label class="campo-resument-item">{{'solicitud-curso.cobertura.email-beneficiario' |
                            translate}} {{ (poliza.tipoPoliza.id === 2) ? i : i + 1 }}:</label>
                        <span class="result-resumen-item">{{ beneficiario.email }}</span>
                    </ng-container>
                </div>
            </ng-container>

            <div id="btn-coberturas-contenedor" class="form-group d-flex justify-content-center">
                <button class="btn-primary" id="btn-coberturas-contra" (click)="descargarPdf()">
                    <span class="material-symbols-outlined"> description </span>
                    {{'solicitud-curso.cobertura.descargar' | translate}}</button>
            </div>
        </div>
        <div id="revisa-correo-contenedor" class="form-group text-center">
            <p class="text-color-primary" [innerHTML]="'solicitud-curso.revisa-correo' | translate"></p>
        </div>
        <div id="form-group" id="content-footer-firma">
            <div class="text-center" id="titulo-footer-firma">{{'solicitud-curso.duda' | translate}}</div>
            <div id="numero-footer-firma" class="text-color-primary text-center">{{ agente!.telefono }}</div>
            <div class="text-center" id="email-footer-firma">
                <a href="{{'mailto:' + agente!.email}}" class="link-email-text">
                    {{'solicitud-curso.duda.escribemos' | translate}}
                </a>
                <a href="{{'mailto:' + agente!.email}}" class="align-middle" id="icono-mail"> <mat-icon>mail</mat-icon>
                </a>
            </div>

        </div>
        <div class="form-group text-center w-100" id="derechos-footer-firma">{{'texto-marca-registrada' | translate}}
        </div>
    </div>
</section>